export default __webpack_public_path__ + "media/images/fondliste-dcc6827dad95fd438f599fb3c2e00caf.png";